import { createAction, props } from '@ngrx/store';
import { IAddBenchmark } from '../models/benckmark.model';

export const loadAddBenchmarks = createAction('[AddBenchmark] Load AddBenchmarks', props<{ request: IAddBenchmark }>());

export const loadAddBenchmarksSuccess = createAction('[AddBenchmark] Load AddBenchmarks Success', props<{ response: boolean }>());

export const loadAddBenchmarksFailure = createAction('[AddBenchmark] Load AddBenchmarks Failure', props<{ error: Error | any }>());
